<template>
    <div class="switch-act-page" v-if="isShow">
        <div class="dialog-mask"></div>
        <div class="switch-act-content mask-content">
            <div class="close-icon" @click="handlerClose"></div>
            <div class="nav-wrap">
                <div class="nav-item" @click="changeNav('ActBenefit')" :class="{ active: name === 'ActBenefit' }">免费领游戏</div>
                <!-- 暂时隐藏、后续打开 -->
                <!-- <div class="nav-item" @click="changeNav('ActGroupBuyVip')" :class="{ active: name === 'ActGroupBuyVip' }">拼团享优惠</div> -->
            </div>
            <component :is="name"></component>
        </div>
    </div>
</template>

<script>
import ActBenefit from './ActBenefit.vue'
import ActGroupBuyVip from './ActGroupBuyVip.vue'

const activitys = {
    1: 'ActBenefit', // 领取免费游戏活动
    2: 'ActGroupBuyVip' // 盒子团购会员活动
}

export default {
    name: 'ActSwitch',
    components: {
        ActBenefit,
        ActGroupBuyVip
    },
    data() {
        return {
            isShow: false,
            name: ''
        }
    },
    watch: {
        isShow: function (value) {
            if (value) {
                this.$EventBus.$on('change-act-nav', (name) => {
                    this.name = name
                })
                this.$nextTick(() => {
                    this.$Utils.setDialogZindex('switch-act-content')
                    document.body.style.overflow = 'hidden'
                })
            } else {
                document.body.style.overflow = ''
            }
        }
    },
    methods: {
        show(value) {
            this.isShow = true
            this.name = activitys[value]
        },
        hide() {
            this.isShow = false
        },
        handlerClose() {
            this.hide()
        },
        changeNav(value) {
            this.name = value
            this.$store.commit('setMessageNum', value)
        }
    }
}
</script>

<style lang="less" scoped>
.switch-act-page {
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    .close-icon {
        position: absolute;
        z-index: 101;
        top: 20px;
        right: -72px;
        width: 50px;
        height: 50px;
        background: url(../../../assets/act/ic_x_50.png) center/100% no-repeat;
    }

    .nav-wrap {
        position: absolute;
        z-index: 101;
        top: 78px;
        left: -192px;

        .nav-item {
            margin-bottom: 20px;
            width: 172px;
            height: 47px;
            background: url(../../../assets/act/act-nav.png) center/100% no-repeat;
            text-align: center;
            line-height: 47px;
            font-size: 24px;
            font-weight: 700;
            cursor: pointer;
            color: #fff;

            &.active {
                color: #090807;
                background-image: url(../../../assets/act/act-nav-h.png);
            }
        }
    }
}
</style>
